<div fxLayout="column" class="container">
    <div class="dialog-title">
        <span>{{studentName}}'s Assignment Attempts</span>
    </div>

    <div fxLayout="column" class="back-white">
        <div class="dialog">
            Click on an assignment attempt to view their work for {{assignmentName}}.
        </div>

        <div class="attempt-list" fxLayout="column" fxLayoutAlign="center center" *ngIf="dataReceived" >
            
            <div  
            *ngFor="let attempt of assignmentAttempts | orderBy: 'AttemptID':'desc'; let i = index"
            [matTooltip]="attempt.SubmitDate ? null : 'View Work will be available for this attempt when it is submitted.'">
                <button 
                [disabled]="!attempt.SubmitDate"
                class="attempt button secondary-button"
                (click)="onViewWork(attempt.AttemptID)">
                    <!-- {{assignmentAttempts.length - i}}.  -->
                    {{attempt.SubmitDate ? 'Submitted ' + attempt.SubmitDate : 'In Progress'}}
                </button>
            </div>            

        </div>

        <div
        class="no-attempts" 
        *ngIf="dataReceived && assignmentAttempts.length == 0">
            There are no attempts for this assignment.
        </div>

        <div *ngIf="!dataReceived" class="spinner-wrapper">
            <div fxLayout="column">
              <mat-spinner [diameter]="50" mode="indeterminate"></mat-spinner>
            </div>
          </div>
    
        <div class="buttons" fxLayout="row" fxLayoutAlign="space-around">
            
    
            <button 
            *ngIf="okButtonString"
            class="button primary-button"
            (click)="onSubmit()"> 
                {{okButtonString}}
            </button>
        </div>
    </div>

    
</div>